module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component.css
// module id = ./src/app/hrms/Departmental-Exam/dept-exam-record/dept-exam-record-from/dept-exam-record-from.component.css
// module chunks = main